<template>
  <v-combobox
    v-model="inputsModel"
    :items="items"
    :search-input.sync="searchInputModel"
    :placeholder="placeholder"
    single-line
    persistent-placeholder
    hide-selected
    hide-details="auto"
    multiple
    small-chips
    class="dynamic-combobox pt-0 mt-0 text-body-2"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <template v-if="searchInputModel">
              <slot name="no-data" :search-input="searchInputModel">
                Press <kbd>enter</kbd> to add
                <strong>{{ searchInputModel }}</strong>
              </slot>
            </template>
            <template v-else>
              <slot name="empty-state">
                Enter a value and press <kbd>enter</kbd> to confirm
              </slot>
            </template>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'DynamicCombobox',
  props: {
    inputs: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    searchInput: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Enter value',
    },
  },
  emits: ['update:inputs', 'update:searchInput'],
  computed: {
    inputsModel: {
      get: function () {
        return this.inputs;
      },
      set: function (value) {
        this.$emit('update:inputs', value);
      },
    },
    searchInputModel: {
      get: function () {
        return this.searchInput;
      },
      set: function (value) {
        this.$emit('update:searchInput', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dynamic-combobox.v-autocomplete:not(.v-input--is-focused).v-select--chips
  input {
  max-height: 25px !important;
}
</style>
